import { PriorityType } from '@shared/enums/priority-type';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';

export const PriorityTypeListConst: IRadioButtonOption<PriorityType>[] = [
  {
    label: 'low',
    value: PriorityType.Low,
  },
  {
    label: 'medium',
    value: PriorityType.Medium,
  },
  {
    label: 'high',
    value: PriorityType.High,
  },
  {
    label: 'emergency',
    value: PriorityType.Emergency,
  },
];
